import React from "react";
import styled from "styled-components";
import { style } from "./style";

const Base = styled.span`
  display: inline-block;
  font-size: ${style.vars.fontSize.small};
  line-height: ${style.vars.fontSize.base};
  font-weight: ${style.vars.fontWeight.bold};
  letter-spacing: 1px;
  text-transform: uppercase;
  padding: ${style.vars.borderWidth.base} ${style.vars.whitespace.regular};
  border-radius: ${style.vars.borderRadius.base};
`;

const DefaultWithBorder = styled(Base)`
  color: ${style.colors.grey.dark};
  background: ${style.colors.white};
  padding-top: 0;
  padding-bottom: 0;
  border: ${style.vars.borderWidth.base} solid ${style.colors.grey.light};
`;

const GreyDark = styled(Base)`
  color: ${style.colors.white};
  background: ${style.colors.grey.dark};
`;

const Green = styled(Base)`
  color: ${style.colors.white};
  background: ${style.colors.green.primary};
`;

const BlueDark = styled(Base)`
  color: ${style.colors.white};
  background: ${style.colors.blue.dark};
`;

const Purple = styled(Base)`
  color: ${style.colors.white};
  background: ${style.colors.purple.primary};
`;

const TextWrapper = styled.span`
  position: relative;
  top: 1px; /* Makes sure the text looks vertically centered in the container */
`;

export type BadgeColor = "default" | "grey_dark" | "green" | "blue_dark" | "purple";

const componentForColor: Record<BadgeColor, typeof Base> = {
  default: DefaultWithBorder,
  grey_dark: GreyDark,
  green: Green,
  blue_dark: BlueDark,
  purple: Purple,
};

export type BadgeProps = {
  color?: BadgeColor;
  className?: string;
  // ReactNode allows null/undefined, but we want to make children required, so
  // we use a subset of the ReactNode type here instead.
  children: React.ReactChild | React.ReactFragment;
};

export const Badge: React.FC<BadgeProps> = ({ color = "default", className, children }) => {
  const Container = componentForColor[color];

  return (
    <Container className={className}>
      <TextWrapper>{children}</TextWrapper>
    </Container>
  );
};
